import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { TestTube2 } from "lucide-react";
import { SETTINGS } from "@/constants/testIds";
import { LabeledInput } from "@/components/settings/LabeledInput";
import { GraphPermissionsNote, GraphStatusBadge, GraphTestResult } from "@/components/settings/GraphSettingsParts";

const MONO = "font-mono text-xs";

export function GraphSettings({ settings, graph, setGraph, testResult, testing, onSave, onTest }) {
  const secretSet = Boolean(settings?.graph?.client_secret_set);
  const field = (key) => ({ value: graph[key], onChange: (e) => setGraph({ ...graph, [key]: e.target.value }) });

  return (
    <Card className="p-6 border-slate-200 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-base font-semibold text-slate-900">Microsoft Entra ID / Graph</h3>
          <p className="text-xs text-slate-500 mt-0.5">
            Configuración del App Registration para sincronizar usuarios del tenant.
          </p>
        </div>
        <GraphStatusBadge configured={secretSet} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <LabeledInput label="Tenant ID" {...field("tenant_id")} inputClassName={MONO}
          placeholder="00000000-0000-0000-0000-000000000000" testId={SETTINGS.tenantIdInput} />
        <LabeledInput label="Client ID" {...field("client_id")} inputClassName={MONO}
          placeholder="Application (client) ID" testId={SETTINGS.clientIdInput} />
        <LabeledInput
          className="md:col-span-2" type="password" {...field("client_secret")} inputClassName={MONO}
          placeholder="••••••••••••••••" testId={SETTINGS.clientSecretInput}
          label={<>Client Secret {secretSet && (
            <span className="text-slate-400 normal-case font-normal ml-1">(dejar en blanco para conservar el actual)</span>
          )}</>}
        />
      </div>

      <GraphPermissionsNote />
      <GraphTestResult result={testResult} />

      <div className="mt-6 flex gap-2 justify-end">
        <Button variant="outline" onClick={onTest} disabled={testing}
          className="border-slate-200" data-testid={SETTINGS.testGraphBtn}>
          <TestTube2 className="w-4 h-4 mr-2" strokeWidth={1.75} />
          {testing ? "Probando..." : "Probar conexión"}
        </Button>
        <Button onClick={onSave} className="bg-orange-600 hover:bg-orange-700 text-white"
          data-testid={SETTINGS.saveGraphBtn}>
          Guardar credenciales
        </Button>
      </div>
    </Card>
  );
}
